// Linkify — renders plain text with http(s) URLs as tappable links.
// The briefing is stored/generated as plain text (no HTML), so URLs in it —
// the auto briefing's Google Maps line, or links Ops/captain paste into a
// custom briefing — must become active at render time. Same anchor pattern
// as Ofertas' maps link: Telegram WebApp opens target="_blank" externally.

// Closing paren/bracket/quote excluded so "(https://...)" doesn't swallow
// the wrapper punctuation.
const URL_RE = /(https?:\/\/[^\s<>"')\]]+)/g;

export function Linkify({ text }: { text: string }) {
  const parts = text.split(URL_RE);
  return (
    <>
      {parts.map((part, i) =>
        /^https?:\/\//.test(part)
          ? <a key={i} class="briefing-link" href={part} target="_blank" rel="noopener noreferrer">{part}</a>
          : part
      )}
    </>
  );
}
